import api from './api';

export const getActiveTenders = async (filters = {}) => {
  const params = {
    pageNum: "1",
    pageSize: "100",
    searchTerm: "",
    sortBy: "",
    startDate: "2024-03-20T22:10:19.398Z",
    endDate: "2030-03-20T22:10:19.398Z",
    ...filters
  };

  try {
    const { data } = await api.post('/api/Tender/GetActiveTenders', params);
    console.log('Raw API Response:', data); // Debug log
    return data;
  } catch (error) {
    console.error('Error fetching tenders:', error);
    throw error;
  }
};

export const addTender = async (tenderData) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Validate all required fields
    const requiredFields = [
      'header',
      'department',
      'date',
      'detail',
      'address',
      'email'
    ];

    const missingFields = requiredFields.filter(field => !tenderData[field]);
    if (missingFields.length > 0) {
      throw new Error(`Zorunlu alanlar eksik: ${missingFields.join(', ')}`);
    }

    // Validate file
    if (!tenderData.file && !tenderData.fileUrl) {
      throw new Error('Dosya yüklenmesi zorunludur');
    }

    // Validate dates
    const tenderDate = new Date(tenderData.date);

    if (isNaN(tenderDate.getTime())) {
      throw new Error('Geçersiz ihale tarihi');
    }

    // Kullanıcının seçtiği statusId değerini doğrudan kullan
    console.log('Kullanıcının seçtiği statusId:', tenderData.statusId);
    
    const payload = {
      date: tenderDate.toISOString(),
      department: tenderData.department,
      header: tenderData.header,
      detail: tenderData.detail,
      statusId: tenderData.statusId, // Backend camelCase bekliyor
      kikNo: tenderData.kikNo || null,
      address: tenderData.address || '',
      phone: tenderData.phone || null,
      email: tenderData.email || '',
      subject: tenderData.subject || null,
      placeOfDelivery: tenderData.placeOfDelivery || null,
      dateOfDelivery: tenderData.dateOfDelivery || null,
      tendarOrganizationAddress: tenderData.tendarOrganizationAddress || null,
      detailDescription: tenderData.detailDescription || null,
      deadline: tenderData.deadline ? new Date(tenderData.deadline).toISOString() : null,
      fileUrl: tenderData.fileUrl || '',
      fileBase64: ''
    };

    // Gelen dosya verilerini kontrol et
    console.log('Gelen dosya verisi:', {
      hasFile: !!tenderData.file,
      fileType: tenderData.file?.type,
      fileName: tenderData.file?.name,
      fileSize: tenderData.file ? `${(tenderData.file.size / 1024).toFixed(2)} KB` : 'N/A'
    });

    // Handle file conversion to base64
    if (tenderData.file) {
      // Validate file size (max 10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (tenderData.file.size > maxSize) {
        throw new Error('Dosya boyutu 10MB\'dan büyük olamaz');
      }

      // Validate file type
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(tenderData.file.type)) {
        throw new Error('Sadece PDF ve Word dosyaları kabul edilmektedir');
      }

      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(tenderData.file);
        
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Dosya okunamadı'));
            return;
          }

          // Log file details for debugging
          console.log('Dosya detayları:', {
            originalSize: `${(tenderData.file.size / 1024).toFixed(2)} KB`,
            base64Size: `${(result.length * 0.75 / 1024).toFixed(2)} KB`,
            fileName: tenderData.file.name,
            fileType: tenderData.file.type
          });

          resolve(result);
        };

        reader.onerror = error => {
          console.error('Dosya okuma hatası:', error);
          reject(new Error('Dosya okuma sırasında bir hata oluştu'));
        };
      });
      
      // Assign the complete base64 string to the payload
      payload.fileBase64 = base64;
      
      // Son kontrol - gönderilecek base64 verisi
      console.log('API\'ye gönderilecek base64 verisi kontrolü:', {
        hasData: !!payload.fileBase64,
        startsWithDataPrefix: payload.fileBase64.startsWith('data:'),
        includesBase64Text: payload.fileBase64.includes(';base64,'),
        previewStart: payload.fileBase64.substring(0, 50) + '...'
      })
    };

    console.log('Sending tender payload:', JSON.stringify({
      ...payload,
      fileBase64: payload.fileBase64 ? '(base64 data present)' : '(no file)'
    }, null, 2));

    const response = await api.post('/api/Tender/AddTenders', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    console.log('Add tender response:', response);
    return response;
  } catch (error) {
    console.error('Error adding tender:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      fullError: error
    });
    
    // Backend'den gelen detaylı hata mesajını göster
    if (error.response?.data) {
      console.error('Backend error details:', JSON.stringify(error.response.data, null, 2));
    }
    
    throw error;
  }
};

export const updateTender = async (data) => {
  try {
    // Debug log for incoming data
    console.log('updateTender received data:', {
      guid: data.guid,
      statusId: data.statusId,
      StatusID: data.StatusID
    });
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Validate all required fields
    const requiredFields = [
      'guid',
      'header',
      'department',
      'date',
      'detail',
      'address',
      'email'
    ];

    const missingFields = requiredFields.filter(field => !data[field]);
    if (missingFields.length > 0) {
      throw new Error(`Zorunlu alanlar eksik: ${missingFields.join(', ')}`);
    }

    let fileBase64 = data.fileBase64 || '';
    let keepExistingFile = false;

    // Eğer yeni bir dosya seçilmemiş ve mevcut bir dosya URL'si varsa
    if (!data.file && (data.fileUrl || data.existingFileUrl)) {
      const fileUrl = data.existingFileUrl || data.fileUrl;
      console.log('Mevcut dosya korunacak:', fileUrl);
      keepExistingFile = true;
    } else if (!data.file && !data.fileUrl && !data.existingFileUrl) {
      // Eğer dosya seçilmemiş ve mevcut dosya da yoksa, boş gönder
      fileBase64 = '';
      keepExistingFile = false;
      console.log('Dosya seçilmedi ve mevcut dosya yok, boş gönderiliyor');
    }

    // Convert file to base64 if it's a File object
    if (data.file && data.file instanceof File) {
      // Validate file size (max 10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (data.file.size > maxSize) {
        throw new Error('Dosya boyutu 10MB\'dan büyük olamaz');
      }

      // Validate file type
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(data.file.type)) {
        throw new Error('Sadece PDF ve Word dosyaları kabul edilmektedir');
      }

      fileBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.file);
        
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Dosya okunamadı'));
            return;
          }

          // Log file details for debugging
          console.log('Dosya detayları:', {
            originalSize: `${(data.file.size / 1024).toFixed(2)} KB`,
            base64Size: `${(result.length * 0.75 / 1024).toFixed(2)} KB`,
            fileName: data.file.name,
            fileType: data.file.type
          });

          resolve(result);
        };

        reader.onerror = error => {
          console.error('Dosya okuma hatası:', error);
          reject(new Error('Dosya okuma sırasında bir hata oluştu'));
        };
      });
    }

    // Kullanıcının seçtiği statusId değerini doğrudan kullan
    console.log('updateTender - Gelen veri içindeki statusId:', {
      statusId: data.statusId,
      tip: typeof data.statusId,
      uzunluk: data.statusId ? data.statusId.length : 0,
      tüm_veri: data
    });
    
    const payload = {
      guid: data.guid,
      date: data.date || new Date().toISOString(),
      department: data.department,
      header: data.header,
      detail: data.detail,
      StatusID: data.statusId, // Kullanıcının seçtiği statusId
      // Debug için ek alan
      _debug_statusId_source: 'doğrudan kullanıcıdan',
      kikNo: data.kikNo || '',
      address: data.address,
      phone: data.phone || '',
      email: data.email,
      subject: data.subject || '',
      placeOfDelivery: data.placeOfDelivery || '',
      dateOfDelivery: data.dateOfDelivery || '',
      tendarOrganizationAddress: data.tendarOrganizationAddress || '',
      detailDescription: data.detailDescription || '',
      deadline: data.deadline || '',
      fileBase64: fileBase64,
      keepExistingFile: keepExistingFile,
      existingFileUrl: data.existingFileUrl || data.fileUrl || ''
    };

    console.log('Güncellenecek ihale verisi:', {
      ...payload,
      fileBase64: payload.fileBase64 ? '(base64 data present)' : '(no file)',
      keepExistingFile: payload.keepExistingFile
    });

    const response = await api.post('/api/Tender/UpdateTenders', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('Tender updated successfully:', response);
    return response;

  } catch (error) {
    console.error('Error updating tender:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    throw error;
  }
};

export const deleteTender = async (guid) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    if (!guid) {
      throw new Error('Tender ID is required');
    }

    const response = await api.post('/api/Tender/DeleteTenders', { guid }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    console.log('Delete tender response:', response);
    return response;
  } catch (error) {
    console.error('Error deleting tender:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    throw error;
  }
};
